export const environment = {
    production: true,
    urlBack: 'https://canopia.api.atalaya.ai/api/v1/',
    urlBackOffice: 'https://canopia.atalaya.ai',
    urlFront: 'https://canopia.app.atalaya.ai/login',
    client_id: 'Tmyc3RHrU6OJG7cwRqBkAFsvD9MQir4joUZrDZ7H',
    client_secret:
        'gOBhAypyOqQHbyA49B1vNG8amKs4jvlUu8eqxOgeCRDIztxrppcAO9CsNv8f0wT2ZUV46Ftfa5J3dMtFQrOIxOiRLLuTyX3nH43jBKlFHEaMfv0GAkcz2pmxuqCpGc62',
};
